import React, { useEffect, useState, useCallback } from 'react'
import './ContactUs.scss'
import { RiCheckFill, RiPencilFill } from 'react-icons/ri'
import Tooltip from '@mui/material/Tooltip'
import { FaTimes } from 'react-icons/fa'
import Grid from '@mui/material/Grid'
import CommunityTextField from '../../../Shared/CommunityTextField'

const WebsiteInput = React.memo(({ webURL, setDepartmentInfoEntity, title, attribute }) => {
  const [showCaption, setShowCaption] = useState(true)
  const [caption, setCaption] = useState('')

  useEffect(() => {
    if (webURL) {
      setCaption(webURL)
    }
  }, [webURL])

  const saveCaption = useCallback(() => {
    setShowCaption(true)
    setDepartmentInfoEntity((departmentInfoEntity) => ({
      ...departmentInfoEntity,
      [attribute]: caption
    }))
  }, [attribute, caption, setDepartmentInfoEntity])

  const discardCaption = useCallback(() => {
    setCaption(webURL)
    setShowCaption(true)
  }, [webURL])

  const handleCaptionChange = useCallback(
    (evt) => {
      const value = evt.target.value
      setCaption(value)
    },
    [setCaption]
  )

  const fixedUrl = useCallback(() => {
    if (caption.startsWith('http')) {
      return caption
    } else {
      return `http://${caption}`
    }
  }, [caption])

  return (
    <div className="container-field">
      <label htmlFor="website">{title ? title : 'Website URL'}</label>
      <br />
      {showCaption ? (
        <div className="caption-container-display">
          <Tooltip title={caption} placement="top" arrow>
            <a
              className="website"
              href={caption && fixedUrl()}
              target="_blank"
              rel="noopener noreferrer"
              data-title={caption}
            >
              {caption}
            </a>
          </Tooltip>
          <RiPencilFill className="edit-icon" onClick={() => setShowCaption(false)} />
        </div>
      ) : (
        <div className="caption-input-container">
          <CommunityTextField
            id="website"
            name="website"
            variant="outlined"
            className="form-control"
            value={caption || ''}
            onChange={handleCaptionChange}
          />
          <div className="caption-controls-container">
            <RiCheckFill className="save-caption" onClick={saveCaption} />
            <FaTimes className="discard-caption" onClick={discardCaption} />
          </div>
        </div>
      )}
    </div>
  )
})

export default WebsiteInput
